// extracted by mini-css-extract-plugin
export default {"dashGrid":"Dashboard_dashGrid__AbLim","gridItem":"Dashboard_gridItem__Z6yri","icon":"Dashboard_icon__5FI+Q"};